
<ng-template [ngIf]="!isPeriodicidadePeriodo() && !isPeriodicidadeTodoPeriodo()">
    <div class="input-group date container-datepicker {{containerClasses}}">
        <div class="input-group-prepend input-group-prepend-mode" *ngIf="periodicidades?.length > 0">
            <span class="input-group-text input-prepend-text" *ngIf="inputPrependText">
                {{inputPrependText}}
            </span>            
            <div class="dropdown" *ngIf="canEditPeriodicidade">
                <sgt-periodicidade-picker
                    [periodicidades]="periodicidades"
                    [periodicidade]="periodicidade"
                    (periodicidadeChange)="onChangePeriodicidade($event)"
                    borderTopRightRadius="0px"
                    borderBottomRightRadius="0px"
                    [canSelect]="!disabled">
                </sgt-periodicidade-picker>
            </div>
            <span class="input-group-text" *ngIf="!canEditPeriodicidade" [title]="periodicidade | periodicidade">
                {{periodicidade | periodicidadeSigla}}
            </span>
        </div>    
        <div class="input-group-prepend" *ngIf="withNavigation" (click)="prior()" [title]="priorTitle()">     
            <button type="button" class="btn btn-light" [disabled]="disabled">
                <i class="fas fa-angle-left"></i>
            </button>
        </div>
    
        <input type="text" 
               class="form-control text-center"
               #inputDate
               [class.ng-invalid]="ngControl.invalid"
               (keyup)="onKeyup($event)"
               (blur)="onBlur(inputDate.value)"
               [required]="required"
               [disabled]="disabled"
               [readonly]="readonly">
    
        <!-- Trimestre -->
        <select 
            *ngIf="isPeriodicidadeTrimestral()" class="form-control"
            [ngModel]="trimestre || ''" (ngModelChange)="onChangeTrimestre($event, ngModel.getFullYear())"
            [disabled]="disabled">
            <option [ngValue]="1">Trimestre 1</option>
            <option [ngValue]="2">Trimestre 2</option>
            <option [ngValue]="3">Trimestre 3</option>
            <option [ngValue]="4">Trimestre 4</option>
        </select>
    
        <!-- Semestre -->
        <select 
            *ngIf="isPeriodicidadeSemestral()" class="form-control"
            [ngModel]="semestre || ''" (ngModelChange)="onChangeSemestre($event, ngModel.getFullYear())"
            [disabled]="disabled">
            <option [ngValue]="1">Semestre 1</option>
            <option [ngValue]="2">Semestre 2</option>
        </select>
    
        <div class="input-group-append">
            <button *ngIf="showBtnCalendar" type="button" class="btn btn-light" (click)="show()" tabindex="-1" [disabled]="disabled">
                <i class="far fa-calendar-alt" aria-hidden="true"></i>
            </button>
    
            <button type="button" class="btn btn-light" *ngIf="withNavigation" (click)="next()" [title]="nextTitle()" [disabled]="disabled">
                <i class="fas fa-angle-right"></i>
            </button>        
        </div>
    </div>
</ng-template>

<ng-template [ngIf]="isPeriodicidadePeriodo()">
    <div class="input-group container-datepicker container-datepicker-range {{containerClasses}}">
        <div class="input-group-prepend input-group-prepend-mode" *ngIf="periodicidades?.length > 0">
            <span class="input-group-text input-prepend-text" *ngIf="inputPrependText">
                {{inputPrependText}}
            </span>            
            <div class="dropdown" *ngIf="canEditPeriodicidade">
                <sgt-periodicidade-picker
                    [periodicidades]="periodicidades"
                    [periodicidade]="periodicidade"
                    (periodicidadeChange)="onChangePeriodicidade($event, true)"
                    borderTopRightRadius="0px"
                    borderBottomRightRadius="0px">
                </sgt-periodicidade-picker>
            </div>
            <span class="input-group-text" *ngIf="!canEditPeriodicidade" [title]="periodicidade | periodicidade">
                {{periodicidade | periodicidadeSigla}}
            </span>            
        </div>  

        <sgt-datepicker-range
            [(startDate)]="startDate"
            (startDateChange)="startDateChange.emit($event)"
            [(endDate)]="endDate"
            (endDateChange)="endDateChange.emit($event)"
            [required]="required"
            [disabled]="disabled"
            [readonly]="readonly"
            [autofocus]="autofocus">
        </sgt-datepicker-range>
    </div>
</ng-template>

<!-- Todo Período -->
<ng-template [ngIf]="isPeriodicidadeTodoPeriodo()">
    <div class="input-group container-datepicker container-datepicker-range {{containerClasses}}">
        <div class="input-group-prepend input-group-prepend-mode" *ngIf="periodicidades?.length > 0">
            <span class="input-group-text input-prepend-text" *ngIf="inputPrependText">
                {{inputPrependText}}
            </span>            
            <div class="dropdown" *ngIf="canEditPeriodicidade">
                <sgt-periodicidade-picker
                    [periodicidades]="periodicidades"
                    [periodicidade]="periodicidade"
                    (periodicidadeChange)="onChangePeriodicidade($event, true)"
                    borderTopRightRadius="0px"
                    borderBottomRightRadius="0px">
                </sgt-periodicidade-picker>
            </div>
            <span class="input-group-text" *ngIf="!canEditPeriodicidade" [title]="periodicidade | periodicidade">
                {{periodicidade | periodicidadeSigla}}
            </span>            
        </div>  

        <input type="text" class="form-control text-center" placeholder="Todo período" disabled="disabled" readonly="readonly">
    </div>
</ng-template>



